module.exports = __webpack_public_path__ + "static/img/bg.ee7f91f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AmongUs/bg.png
// module id = tApQ
// module chunks = 1